import { useState } from 'react';
import Loader from './loader';
import { Icon } from '@mui/material';

const FaIcon = ({ onClick, style, icon, title }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    await onClick();
    setLoading(false);
  };

  return loading ? (
    <Loader />
  ) : (
    <Icon
      role='img'
      title={title}
      style={{
        margin: '0px 5px',
        cursor: onClick ? 'pointer' : 'default',
        ...style,
      }}
      fontSize='small'
      onClick={onClick ? () => handleClick() : null}
    >
      {icon}
    </Icon>
  );
};

export default FaIcon;
